var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.361,
    height: 16.672,
    viewBox: "0 0 19.361 16.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(-25.139 -16.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M20664.182-22224.01l-7.629,7.629,7.629,7.629",
    transform: "translate(-20630 22241)",
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M0,0H17",
    transform: "translate(27.5 24.5)",
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ecaf02533063f53e8c5d6e1d34159422.svg";
export { ForwardRef as ReactComponent };